module.exports = __webpack_public_path__ + "img/9788995529737.bd4fa32c.jpg";